<template>
  <div id="ArtistSelect" class="extended-forms">
    <div class="row">
      <div v-bind:class="getArtistClass()">
        <h4 class="card-title text-left" v-show="showTitle">아티스트</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <!--            <el-select class="select-primary" size="large" placeholder="유닛선택" v-model="units.unitId" @change="onUnitChange">-->
            <!--              <el-option v-for="option in units.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>-->
            <!--            </el-select>-->
            <v-select
              class="select-primary"
              size="large"
              placeholder="유닛선택"
              :clearable="false"
              :options="units.options"
              label="label"
              :reduce="(label) => label.value"
              v-model="units.unitId"
              :multiple="isMultiple"
              :filter-by="filterArtistOption"
            >
            </v-select>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-show="showMembers">
        <h4 class="card-title text-left" v-show="showTitle">멤버</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select class="select-primary" size="large" placeholder="멤버선택" v-model="members.artistId" @change="sendArtistInfo">
              <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { UserData } from "@/util/UserData";

export default {
  name: "ArtistSelect",
  async created() {
    await this.getArtistUnits();

    this.members = {
      artistId: this.initialMemberId || null,
      options: [],
    };
    await this.getArtistMembers();
  },
  watch: {
    units: {
      handler() {
        this.onUnitChange(this.currentIndex);
      },
      deep: true,
    },
    // selectedUnitId: {
    //   handler() {
    //     this.units.unitId = this.selectedUnitId;
    //   },
    // },
  },
  data() {
    return {
      units: {
        unitId: null,
        options: [],
      },
      members: {
        artistId: null,
        options: [],
      },
    };
  },
  props: {
    isMultiple: {
      type: Boolean,
      default: false,
      required: false,
    },
    currentIndex: {
      type: Number,
      required: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
      required: false,
    },
    includeUnitArtist: {
      type: Boolean,
      default: false,
      required: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showAllUnits: {
      type: Boolean,
      required: false,
    },
    showMembers: {
      type: Boolean,
      default: true,
    },
    initialUnitId: {
      type: Number,
      required: false,
    },
    selectedUnitId: {
      type: [Number, Array],
      required: false,
    },
    initialMemberId: {
      type: Number,
      required: false,
    },
  },
  methods: {
    async getArtistUnits() {
      return this.$axios.get(`/artistUnit?isFilter=1`).then((res) => {
        const data = res.data.data;
        if (this.showAllUnits) {
          this.units.options.push({ label: "전체", value: null });
        }
        if (data?.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName;
            option.value = item.unitId;
            option.artistId = item.artistId;
            option.isGroup = item.isGroup;
            option.name = item.name;
            option.blipName = item.blipName;
            option.path = item.path;
            this.units.options.push(option);
          });
        }
        if (this.initialUnitId) {
          if (this.initialUnitId === 0) {
            this.units.unitId = null;
          } else {
            this.units.unitId = this.initialUnitId;
          }
        } else {
          if (this.isFilter) {
            this.units.unitId = UserData.get("lastUnitId") ?? data[0].unitId;
          } else {
            if (this.initialUnitId === 0 || typeof this.currentIndex === "number") {
              this.units.unitId = null;
              this.onUnitChange(this.currentIndex);
            } else {
              this.units.unitId = data[0].unitId;
            }
          }
        }
      });
    },

    async getArtistMembers() {
      if (this.units.unitId) {
        return this.$axios.get(`/artistUnit/${this.units.unitId}/members`, null).then((res) => {
          this.members.options = [];
          const data = res.data.data;
          this.members.options.push({ label: "전체", value: null });
          if (this.includeUnitArtist) {
            this.units.options.forEach((unit) => {
              if (this.units.unitId === unit.value && unit.isGroup === 1) {
                this.members.options.push({ label: unit.label, value: unit.artistId, isUnitArtist: true });
              }
            });
          }
          if (data?.length > 0) {
            data.forEach((item) => {
              const option = {};
              option.label = item.blipName;
              option.value = item.artistId;
              if (item.isVisible === 1) {
                this.members.options.push(option);
              }
            });
            this.sendArtistInfo();
          }
        });
      } else {
        this.sendArtistInfo();
      }
    },
    onUnitChange(currentIndex) {
      this.members = {
        artistId: null,
        options: [],
      };
      if (!this.isMultiple) {
        if (this.isFilter) {
          UserData.set("lastUnitId", this.units.unitId);
        }
        this.getArtistMembers();
        this.$emit("unitChangeEvent", {
          unitId: this.units.unitId,
          unitName: this.units.options.filter((option) => option.value === this.units.unitId)[0].label,
          currentIndex,
        });
      } else {
        this.$emit("unitChangeEvent", {
          unitId: this.units?.unitId,
          unitName: this.units?.options
            .filter((option) => this.units.unitId?.includes(option.value))
            .map((option) => option.label)
            .toString(),
        });
      }
    },
    filterArtistOption(option, label, search) {
      const needle = (search || "").toLowerCase();
      const haystack = [label, option.label, option.name, option.blipName, option.path, option.value].filter(Boolean).join(" ").toLowerCase();
      return haystack.includes(needle);
    },
    sendArtistInfo() {
      if (this.units.unitId) {
        this.$emit("memberChangeEvent", {
          unitId: this.units.unitId,
          unitName: this.units.options.filter((option) => option.value === this.units.unitId)[0].label,
          memberId: this.members.artistId,
          memberName: this.members.options.filter((option) => option.value === this.members.artistId)[0].label,
          isUnitArtist: this.members.options.filter((option) => option.value === this.members.artistId)[0].isUnitArtist,
        });
      } else {
        this.$emit("memberChangeEvent", {
          unitId: this.units.unitId,
          memberId: this.members.artistId,
        });
      }
    },
    getArtistClass() {
      return {
        "col-md-6": this.showMembers,
        "col-md-12": !this.showMembers,
      };
    },
  },
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
}
.vs__dropdown-toggle {
  border: 1px solid rgb(0 0 0);
  padding: 6px 0 6px 0;
}
.vs__selected {
  color: #ff35e6;
}
</style>
